class Utils {
  static isEmptyString(string: string): boolean {
    return string.length === 0;
  }
}

export default Utils;